<template>
  <v-container class="view">
    <v-spacer></v-spacer>

    <!---------update account form-------->
    <update-profile />
    <v-container>
      <p class="text-hidden"></p>
      <!--profile card-->
      <v-spacer></v-spacer>
      <v-card
        elevation="0"
        style="
          display: flex;
          justify-content: center;
          align-items: flex-end;
          position: relative;
        "
      >
        <v-avatar size="100" color="var(--purple)" tile rounded>
          <span
            v-if="!profile_picture_url"
            class="text-uppercase white--text"
            >{{ firstname[0] + lastname[0] }}</span
          >
          <img
            :src="profile_picture_url"
            :alt="firstname + ' ' + lastname"
            v-else
          />
        </v-avatar>

        <!-------update user image------>
        <upload-avatar />
      </v-card>
      <v-row justify="center" align="center">
        <v-col cols="12" sm="6">
          <profile-info
            v-for="information in accountInformation"
            :key="information.field"
            :field="information.field"
            :value="information.value"
          ></profile-info>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>



<script>

import UpdateProfile from "./../../components/UserAccountUpdateProfile.vue";
import UploadAvatar from "./../../components/UserAccountUploadAvatar.vue";
import ProfileInfo from "./../../components/ProfileInfo.vue";

//import user data from central store
import store from "@/store";
export default {
  components: {
    UpdateProfile,
    UploadAvatar,
    ProfileInfo,
  },
  data: () => ({
    //valid_form: false,
    edit: false,
    show: true,
    loading: false,
    loader: null,
    timeout: -1,
    userPassword: "",
    valid: true,
    value: true,
    //user information
    userInformation: null,
  }),

  computed: {
    //get user profile from central store here
    firstname: () => store.getters["auth/user"].firstname,
    lastname: () => store.getters["auth/user"].lastname,
    email: () => store.getters["auth/user"].email,
    bio: () => store.getters["auth/user"].bio,
    username: () => store.getters["auth/user"].username || "not provided",
    phone: () => store.getters["auth/user"].phone || "not provided",
    profile_picture_url: () => store.getters["auth/user"].profile_picture_url,

    accountInformation: () => {
      let detail = store.getters["auth/user"];
      return [
        { field: "firstname", value: detail.firstname },
        { field: "lastname", value: detail.lastname },
        { field: "E-Mail", value: detail.email },
        { field: "username", value: detail.username },
        { field: "phone", value: detail.phone },
      ];
    },
  },
  //user account information
};
</script>
<style scoped>
.text-hidden {
  display: hidden;
  margin-top: 7.5vh;
}
</style>